// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner--spinner--nb2smAm","rotate":"Spinner--rotate--AZUL_Et"};